/* eslint max-len:0 */
import { get, includes, Dictionary } from 'lodash';
import * as moment from 'moment';

export const translations: Dictionary<object> = {
  de: {
    time: {
      dayN: 'Tag {n}',
      days: 'Tage',
      hours: 'Stunden',
      minutes: 'Minuten',
      relative: {
        on: 'am {dateString}',
        today: 'heute',
        tomorrow: 'morgen',
        yesterday: 'gestern',
      },
      seconds: 'Sekunden',
      shortDate: 'dd. MM ’YY',
    },
  },
  en: {
    time: {
      dayN: 'Day {n}',
      days: 'days',
      hours: 'hours',
      minutes: 'minutes',
      relative: {
        on: 'on {dateString}',
        today: 'today',
        tomorrow: 'tomorrow',
        yesterday: 'yesterday',
      },
      seconds: 'seconds',
      shortDate: 'MMM dd ’YY',
    },
  },
};

export let currentLocale = 'en';
const supportedLanguages = Object.keys(translations);

export function translate(stringName: string, options = {}): string | null {
  const localizedTranslations =
    translations[currentLocale || 'en'] || translations.en;
  let translation = get(localizedTranslations, stringName);
  if (!translation) {
    return null;
  }
  if (typeof translation !== 'string') {
    // tslint:disable-next-line:no-console
    console.error('String for', stringName, 'has invalid class.');
    return null;
  }
  translation = translation.replace(/\{[a-zA-Z1-9]+\}/g, (keyWithCurlyBraces) => {
    const key = keyWithCurlyBraces.replace(/{/, '').replace('}', '');
    return options[key] || keyWithCurlyBraces;
  });
  return translation;
}

export function setLocale(locale: string) {
  currentLocale = includes(supportedLanguages, locale) ? locale : 'en';
  moment.locale(locale);
}

export const t = translate;



// WEBPACK FOOTER //
// ./src/lib/i18n.ts